export default[
    {
        path: '/trabalhador/epi/cadastro/:trabalhador_id',
        name: 'cadastro do epi', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/comissionador/trabalhador/lista',
        name: 'lista comissionador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/trabalhador/epi/editar/:id/:trabalhador_id',
        name: 'editar epi', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]